import React, { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { IRevenueResult } from '../ReportDashboard/RevenueCard/Client/IRevenue'

import { Client } from './Client/Client'
import { IProjectedEarnings } from './Client/IProjectedEarnings'
import { ProjectedEarningsChart } from './components/ProjectedEarningsChart/ProjectedEarningsChart'
import {
  ChartContainer,
  ContentContainer,
  ContentContainerHeader,
  MainContainer,
} from './style'

export const ProjectedEarnings: FunctionComponent = () => {
  const { t } = useTranslation()
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth)
  const [projectedEarningsData, setProjectedEarningsData] =
    useState<IProjectedEarnings>()

  const [revenueData, setRevenueData] = useState<IRevenueResult>()

  useEffect(() => {
    Client.getProjectedEarnings().then(earnings => {
      setProjectedEarningsData(earnings)
    })

    Client.getRevenueData().then(revenue => {
      setRevenueData(revenue)
    })

    window.addEventListener('resize', () => setWindowWidth(window.innerWidth))
    return () => {
      window.removeEventListener('resize', () =>
        setWindowWidth(window.innerWidth),
      )
    }
  }, [])

  return (
    <MainContainer>
      <ChartContainer>
        <ContentContainerHeader>
          {t(`Projected earnings`)}
        </ContentContainerHeader>
        <ContentContainer width={windowWidth}>
          <ProjectedEarningsChart
            projected={projectedEarningsData}
            revenue={revenueData}
          />
        </ContentContainer>
      </ChartContainer>
    </MainContainer>
  )
}
